type Params = Record<string, string | number>;
type ReplacePathParamsFunction = (path: string, params: Params, prefix?: string) => string;

export const replacePathParams: ReplacePathParamsFunction = (path, params, prefix = ':') => {
  let newPath = path;

  Object.entries(params).forEach(([key, value]) => {
    newPath = newPath.replace(prefix + key, String(value));
  });

  return newPath;
};
